<script>
  import {sgettext} from '../../i18n.js';
  export let controls = [];
</script>

<style>
  .icon {
    width: 64px;
    margin-right: 30px;
    font-size: 10px;
    padding: 15px;
  }
  .icon img {width: 100%;}
  .control {
    display: flex;
  }
  .detail {
    flex: 1;
  }

  .hazard-controls {
    border: 1px solid #e9edef;
  }

  section header {padding: 10px 15px; background-color: #e9edef;}
  section header h4 {margin: 0;}
  section .detail {padding: 15px;}
</style>

<section>
  <header><h4>{sgettext('$$CONTROLS$$')}</h4></header>
  <div class="hazard-controls">
    {#each controls as c}
      <div class="control">
        <div class="icon">
          {#if c.icon}
          <img src={c.icon.url} alt={c.icon.name} />
          {/if}
        </div>
        <div class="detail">
          {#if c.expired}
            <div class="name text-danger">
              <i class="fa fa-exclamation-circle text-danger" title="{sgettext('$$GLOBAL_CONTROL_EXPIRED_1$$')}"></i>
              {c.name}
            </div>
          {:else}
            <div class="name">{c.name}</div>
          {/if}
          <div class="description">{c.description}</div>
        </div>
      </div>
    {/each}
    {#if controls.length === 0}
    <div class="detail">{sgettext('$$NOT_SELECTED_CONTROL_RISK_CLICK_BACK_ADD$$')}</div>
    {/if}
  </div>
</section>
